import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ActionStatus } from "../enums";
import { AddTask, CommonWebService, HttpResponse, SearchProjectForm, TaskActivityLogEntry, TaskDetail, TaskListApiData, UserHttpService } from "../public-api";

@Injectable({
    providedIn: 'root'
})
export class TaskService {

    constructor(
        private http: HttpClient,
        private commonService: CommonWebService,
        private userSessionService: UserHttpService
    ) { }


    public addTask(body: AddTask, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);

        formData.append("task_title", body.task_title ? body.task_title : "");
        formData.append("task_type_id", body.task_type_id ? body.task_type_id : "");
        formData.append("client_id", body.client_id ? body.client_id : "");
        formData.append("project_id", body.project_id ? body.project_id : "");
        formData.append("communication_received_from", body.communication_received_from ? body.communication_received_from : "");
        formData.append("communication_send_to", body.communication_send_to ? body.communication_send_to : "");
        formData.append("email_subject", body.email_subject ? body.email_subject : "");
        formData.append("communication_date", body.communication_date ? this.commonService.changeDateFormat(body.communication_date as Date) : "");
        formData.append("task_start_date", body.task_start_date ? this.commonService.changeDateFormat(body.task_start_date as Date) : "");
        formData.append("task_end_date", body.task_end_date ? this.commonService.changeDateFormat(body.task_end_date as Date) : "");
        formData.append("task_hours", body.task_hours ? body.task_hours : "");
        formData.append("task_status", body.task_status ? body.task_status : ActionStatus.PENDING);
        formData.append("task_priority", body.task_priority ? body.task_priority : "");
        formData.append("task_alert_require", body.task_alert_require ? body.task_alert_require : "");
        formData.append("task_comments", body.task_comments ? body.task_comments : "");
        formData.append("taskuser_ids", body.taskuser_ids ? body.taskuser_ids : "");

        if (isEdit && body.task_id) {
            formData.append("task_id", body.task_id ? body.task_id : "");
        };

        return this.http.post<HttpResponse<any>>('mytask/createTask', formData);
    }

    public taskList(searchParams?: SearchProjectForm): Observable<HttpResponse<TaskListApiData>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        if (searchParams && searchParams.clientId) {
            formData.append("client_id", searchParams.clientId ? searchParams.clientId : "");
        }
        if (searchParams && searchParams.project_id) {
            formData.append("project_id", searchParams.project_id ? searchParams.project_id : "");
        }
        if (searchParams && searchParams.fromDate) {
            formData.append("fromDate", searchParams.fromDate ? searchParams.fromDate : "");
        }
        if (searchParams && searchParams.toDate) {
            formData.append("toDate", searchParams.toDate ? searchParams.toDate : "");
        }
        if (searchParams && searchParams.status) {
            formData.append("status", searchParams.status);
        }
        if (searchParams && searchParams.activeStatus) {
            formData.append("activeStatus", searchParams.activeStatus);
        }
        if (searchParams && searchParams.task_status) {
            formData.append("task_status", searchParams.task_status);
        }
        return this.http.post<HttpResponse<TaskListApiData>>('mytask/myTask', formData);
    }

    public updateTaskActiveStatus(params: {
        task_id: string;
        comments: string;
        active_status: string;
    }): Observable<HttpResponse<any>> {
        const formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("task_id", params.task_id);
        formData.append("comments", params.comments);
        formData.append("active_status", params.active_status);
        return this.http.post<HttpResponse<any>>('mytask/ActiveTask', formData);
    }

    public taskActivityLog(taskId: string): Observable<HttpResponse<TaskActivityLogEntry[]>> {
        const formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("task_id", taskId);
        return this.http.post<HttpResponse<TaskActivityLogEntry[]>>('mytask/ActiveTask/taskActivityLog', formData);
    }

    public deleteTask(id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("task_id", id ? id : "")
        return this.http.post<HttpResponse<any>>('mytask/taskDelete', formData);
    }

    public taskDetail(id: string): Observable<HttpResponse<TaskDetail[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("task_id", id ? id : "")
        return this.http.post<HttpResponse<TaskDetail[]>>('mytask/taskDetail', formData);
    }
}